import { ColorsType } from '../../utils/colors.type';

export const ColorsPalette: ColorsType = {
  brand: '#071389',
  brand_background: '#DFF1FD',
  brand_linear_gradient: 'linear-gradient(90deg, #071389 0%, #DFF1FD 100%)',

  primary_button_background: '#071389',
  primary_button_background_hover: '#0B1CB0',
  primary_button_background_after: '#FFFFFF',

  secondary_button_background: '#DFF1FD',
  secondary_button_background_hover: '#CFEAFB',
  secondary_button_background_after: '#FFFFFF',

  outline_button_background: '#FFFFFF',
  outline_button_background_hover: '#FFFFFF',
  outline_button_background_after: '#FFFFFF',

  select_button_background: '#FFFFFF',
  select_button_background_selected: '#0713891A',
  select_button_background_after: '#071389',

  outline_button_border: '#071389',
  outline_button_border_hover: '#071389',

  select_button_border: '#07138980',
  select_button_border_hover: '#071389',
  select_button_border_selected: '#071389',

  text_primary_button: '#FFFFFF',
  text_secondary_button: '#071389',
  text_outline_button: '#071389',
  text_outline_button_hover: '#071389',
  text_select_button: '#071389',

  text_link: '#071389',
  text_header: '#000000',
  text_primary_paragraph: '#000000',
  text_secondary_paragraph: '#575757',

  text_input: '#575757',
  text_input_selected: '#000000',

  text_inactive: '#575757',

  input_border: '#CCCCCC',
  input_border_hover: '#000000',
  input_border_selected: '#000000',

  checkbox_border: '#979797',
  checkbox_border_hover: '#BCC2E2',
  checkbox_background_hover: '#E2E5F333',

  switch_background_selected: '#FFFFFF',

  error_base: '#FF0000',
  text_error_notification: '#FFFFFF',
  error_hover: '#FF0000',

  tonal_base: '#F6F6F6',
  tonal_hover: '#EFF3F5',

  container_background: '#FFFFFF',
  infotip_background: '#EFF3F5',
  dimmed_background: '#000000',
  icons_endorsement: '#829098',
  divider: '#F0F0FF',
  UE: '#4545FF',

  footer_primary_background: '#ffffff',
  footer_secondary_background: '#ffffff',
  text_footer: '#FFFFFF',

  dropdown_shadow: '0px 2px 8px rgba(58, 58, 58, 0.1)',
  content_box_shadow: '0px 6px 12px rgba(58, 58, 58, 0.1)',
  switch_shadow: '0px 5px 10px rgba(58, 58, 58, 0.1)',
  modal_shadow: '0px 10px 40px rgba(0, 0, 0, 0.15)',
} as const;
